/**
 * Clean App.js - Fresh start without Redux
 */
import React from "react";
import { ThemeProvider } from "@emotion/react";
import { CssBaseline } from "@mui/material";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import "./App.css";
import { theme } from "./theme";
import { initPostHog } from "./analytics/posthogClient";

// Layout
import Layout from "./components/layout/Layout.simple";
import EmailVerificationGate from "./components/auth/EmailVerificationGate";

// Pages
import Home from "./pages/Home";
import Solver from "./pages/Solver";
import Trainer from "./pages/Trainer";
import Play from "./pages/Play";
import Analysis from "./pages/Analysis";
import WelcomeAuth from "./pages/WelcomeAuth";
import Onboarding from "./pages/Onboarding";

function AuthedAppShell() {
  const enableAuthGate = (process.env.REACT_APP_ENABLE_AUTH_GATE || "true").toLowerCase() !== "false";
  const routes = <Outlet />;
  if (!enableAuthGate) return routes;
  return <EmailVerificationGate>{routes}</EmailVerificationGate>;
}

function App() {
  React.useEffect(() => {
    initPostHog();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Routes>
            <Route path="/welcome" element={<WelcomeAuth />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route element={<AuthedAppShell />}>
              <Route path="/" element={<Home />} />
              <Route path="/trainer" element={<Trainer />} />
              <Route path="/play" element={<Play />} />
              <Route path="/analysis" element={<Analysis />} />
              <Route
                path="/cash"
                element={
                  <Layout>
                    <Solver initialLookupMode="cash" allowLookupModeSwitch={false} />
                  </Layout>
                }
              />
              <Route
                path="/mtt"
                element={
                  <Layout>
                    <Solver initialLookupMode="mtt" allowLookupModeSwitch={false} blankMode={true} />
                  </Layout>
                }
              />
              <Route
                path="/spin-and-go"
                element={
                  <Layout>
                    <Solver initialLookupMode="mtt" allowLookupModeSwitch={false} blankMode={true} />
                  </Layout>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
          <Analytics />
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
